export default __webpack_public_path__ + "static/media/atsResume.8de5c417.pdf";